import React, { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { useFeatureFlags } from 'hooks';

const ActiveLink = ({ goToRoute }) => {
  const location = useLocation();
  if (goToRoute !== location.pathname) return null;
  return <div className="DashboardSidebar--unify-activeLink" />;
};

const NavigationLink = ({
  hasUnificationFlag,
  onMount,
  if: navIf,
  ...props
}) => (
  <NavLink
    className="LearnNavLink"
    activeClassName={classNames(
      'CustomColor--borderColor DashboardSidebar-link--active',
      {
        'fw-b': hasUnificationFlag,
      },
    )}
    {...props}
  />
);

function Link(props) {
  const { to, onMount } = props;
  const hasUnificationFlag = useFeatureFlags('readiness-enable-unification');

  useEffect(() => {
    if (onMount) {
      onMount({ to });
    }
  }, [onMount, to]);

  if (hasUnificationFlag) {
    return (
      <>
        {hasUnificationFlag && <ActiveLink goToRoute={to} />}
        <NavigationLink hasUnificationFlag={hasUnificationFlag} {...props} />
      </>
    );
  }

  return <NavigationLink hasUnificationFlag={hasUnificationFlag} {...props} />;
}

export default Link;
